import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import appParameters from '../../components/utils/AppParameters';
import apiServiceUtils from '../utils/ApiServiceUtils';

export const DescriptionMenuContent = React.createClass({
    removeLink(description) {
        if (!description)
            return '';

        var index = description.indexOf('<a href=');

        if (index != -1) {
            description = description.substring(0, index);

            index = description.indexOf('<br');

            if (index != -1)
                description = description.substring(0, index);
        }

        return description;
    },
    render () {
        if (!this.props.showDescription)
            return (<div/>);

        const width = 600;
        const height = 250;
        var center = (this.props.windowWidth - properties.BROWSER_WIDTH) / 2;
        const leftPosition = center - width / 2;
        const topPosition = properties.CLIPART_BUTTON_HEIGHT_OLD + apiServiceUtils.getNoInternetConnectionAlertHeight();

        const menuStyle = {
            position: 'absolute',
            left: leftPosition,
            top: topPosition + 12,
            width: width,
            height: height,
            background: '#fafafa',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            borderRadius: 20
        };

        const stemSize = properties.RECORD_TOOLTIP_STEM_SIZE;

        const stemStyle = {
            position: 'absolute',
            top: - 2 * stemSize,
            left: width / 2 - stemSize,
            borderStyle: 'solid',
            borderWidth: stemSize,
            borderBottomColor: '#fafafa',
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent'
        };

        const verticalGap = 50;
        const horizontalGap = 10;

        //thumb size 512x384
        var thumbnailSrc = '/file/ci/' + appParameters.navBarThumbnailId + '/thumb';
        var thumbHeight = height - 2 * verticalGap;
        var thumbWidth = thumbHeight * 512 / 384;

        const titleStyle = {
            position: 'absolute',
            top: 20,
            left: horizontalGap,
            color: properties.BROWSER_SELECTED_COLOR,
            fontSize: 17,
            fontWeight: 'bold',
            width: width - thumbWidth - 3 * horizontalGap,
            textAlign: 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const descriptionStyle = {
            position: 'absolute',
            top: 50,
            left: horizontalGap,
            color: properties.BROWSER_SELECTED_COLOR,
            fontSize: 12,
            width: width - thumbWidth - 3 * horizontalGap,
            height: height - 50 - 20,
            textAlign: 'left',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const thumbnailStyle = {
            position: 'absolute',
            top: verticalGap,
            right: horizontalGap,
            width: thumbWidth,
            height: thumbHeight
        };

        return (
            <div className='describeItem' style={menuStyle}>
                <div className='describeItem' style={stemStyle}></div>
                <span className='describeItem' style={titleStyle}>{appParameters.navBarTitle}</span>
                <span className='describeItem' style={descriptionStyle}>{this.removeLink(appParameters.navBarDescription)}</span>
                <img alt='' aria-hidden='true' className='describeItem' style={thumbnailStyle} src={thumbnailSrc}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var showDescription = state.menu.showDescription;

    if (showDescription == undefined)
        showDescription = false;

    return {
        showDescription
    };
}

export const DescriptionMenu = connect(mapStateToProps)(DescriptionMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/DescriptionMenu.js
 **/